export function normalizeAdsPracticeId(value) {
    if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
        return null;
    }
    const id = Number(String(value).trim());
    return Number.isInteger(id) && id > 0 ? id : null;
}

export function resolveAdsPracticeId(explicitPracticeId, state) {
    const explicit = normalizeAdsPracticeId(explicitPracticeId);
    if (explicit !== null) return { practiceId: explicit, reportScoped: true };
    return {
        practiceId: normalizeAdsPracticeId(state?.practiceTreatmentList?.practiceId),
        reportScoped: false,
    };
}

export function hasAdsReportingFeatureAccess(featureName, practiceId, state) {
    const expected = normalizeAdsPracticeId(practiceId);
    const analytics = state?.analyticsReports || {};
    const snapshot = normalizeAdsPracticeId(analytics.adsReportingPermissionsPracticeId);
    if (expected === null || snapshot !== expected || analytics.adsReportingPermissionsStatus !== 'ready') return false;
    const level = analytics.adsReportingPermissions?.[featureName];
    return level === 'view' || level === 'manage';
}

export function isCurrentAdsReportingPractice(practiceId, state) {
    const expected = normalizeAdsPracticeId(practiceId);
    const current = normalizeAdsPracticeId(state?.analyticsReports?.adsReportingPracticeId);
    return expected !== null && expected === current;
}
